import styled from 'styled-components';
import { Radio } from 'antd';

const BLUE_COLOR = '#2F54EB';

export const RadioGroupWrapper = styled(Radio.Group)`
	gap: 24px;
	width: 100%;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
`;

export const RadioGroupButtonWrapper = styled(Radio.Button)`
	&.ant-radio-button-wrapper {
		height: auto;
		max-height: 56px;
		padding: 10px 16px;
		border: 1px solid #d9d9d9;
		border-radius: 8px;
		background: #ffffff;
		transition: all 0.2s;
		width: 100%;

		&::before {
			display: none !important;
		}

		&.ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']):first-child {
			border: none !important;
		}

		&:hover {
			background-color: #f5f5f5;
			color: ${BLUE_COLOR};
		}

		&.ant-radio-button-wrapper-checked {
			background: #ebeefd;
			border-color: #ebeefd;
			color: ${BLUE_COLOR};

			&:hover {
				background: #ebeefd !important;
				border-color: #ebeefd !important;
				color: ${BLUE_COLOR} !important;
			}
		}

		&.ant-radio-button-wrapper-disabled {
			background: none;
			border-color: #f0f0f0;
			color: #bfbfbf;
			cursor: not-allowed;

			&:hover {
				background: none !important;
				border-color: #f0f0f0 !important;
				color: #bfbfbf !important;
			}

			svg,
			i {
				color: #bfbfbf !important;
			}
		}

		.ant-radio-button {
			display: none;
		}
	}
`;

export const ReportContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

export const LeftContent = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
`;

export const IconWrapper = styled.div`
	flex-shrink: 0;
	width: 24px;
	height: 24px;
	margin-right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;

	svg,
	i {
		width: 100%;
		height: 100%;
		vertical-align: middle;
	}

	.ant-radio-button-wrapper-checked & {
		svg,
		i {
			color: ${BLUE_COLOR} !important;
		}
	}

	.ant-radio-button-wrapper-checked:hover & {
		svg,
		i {
			color: ${BLUE_COLOR} !important;
		}
	}

	.ant-radio-button-wrapper-disabled & {
		svg,
		i {
			color: #bfbfbf !important;
		}
	}
`;

export const NameWrapper = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: #262626;
	flex-grow: 1;

	.ant-radio-button-wrapper:hover:not(.ant-radio-button-wrapper-checked):not(.ant-radio-button-wrapper-disabled) & {
		color: ${BLUE_COLOR} !important;
	}

	.ant-radio-button-wrapper-checked & {
		color: ${BLUE_COLOR} !important;
	}

	.ant-radio-button-wrapper-disabled & {
		color: #bfbfbf !important;
	}
`;

export const CustomReportsSpan = styled.span`
	background: #f0f0f0;
	color: #595959;
	padding: 2px 6px;
	border-radius: 6px;
	min-width: 48px;
	min-height: 16px;
	text-align: center;
	border: 1px solid transparent;

	.ant-radio-button-wrapper:hover:not(.ant-radio-button-wrapper-checked):not(.ant-radio-button-wrapper-disabled) & {
		color: ${BLUE_COLOR} !important;
		border-color: ${BLUE_COLOR} !important;
	}

	.ant-radio-button-wrapper-checked & {
		border-color: ${BLUE_COLOR} !important;
		background: #ebeefd;
		color: ${BLUE_COLOR} !important;
	}

	.ant-radio-button-wrapper-disabled & {
		background: #f5f5f5;
		color: #bfbfbf !important;
		border-color: transparent !important;
	}
`;
